import React, { memo, useMemo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { useBloc } from '@core/utils/bloc';
import { CommonService } from '@business/services';
import { ProcedureWidgetForm, ProcedureBlockVariation } from './ProcedureBlock';
import { ProcedureBlockBloc } from './ProcedureBlockBloc';
import { R } from '@core/utils/r';
import { CompactLibraryItemResponse } from '@business/entities/library';

export interface EmbedBlockSettingsProps {
  form: ProcedureWidgetForm;
  variation: ProcedureBlockVariation;
}

export const ProcedureBlockSettings = memo((props: EmbedBlockSettingsProps) => {
  const { form, variation } = props;
  const bloc = useBloc(ProcedureBlockBloc, variation);
  const data = useObservable(bloc.items$);
  const items = useMemo(() => CommonService.selectItems(data || [], 'name', 'id'), [data]);

  const onChange = useCallback(
    (value: string) => {
      const procedure = R.first(R.filter(data, (p: CompactLibraryItemResponse) => p.id === value)) as CompactLibraryItemResponse;
      if (procedure) {
        form.patchValue({ text: procedure.content as string, heading: procedure.name });
      }
    },
    [data, form],
  );

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} />
    </div>
  );
});
